import React from 'react';

const MonitoreoDoctores = () => {
  const [doctores, setDoctores] = React.useState([]);

  React.useEffect(() => {
    fetch('/api/admin/doctores-monitoreo')
      .then(res => res.json())
      .then(data => setDoctores(data))
      .catch(console.error);
  }, []);

  return (
    <table 
    className="shadow-lg"
    style={{
      width: '100%',
      borderCollapse: 'collapse',
      fontFamily: 'Arial, sans-serif'
    }}>
      <thead className="bg-blue-600 text-white">
        <tr>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Nombre</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Edad</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Teléfono</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Especialidad</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Cédula</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Pacientes Asignados</th>
          <th style={{ padding: '12px', border: '1px solid #ddd' }}>Citas Agendadas</th>
        </tr>
      </thead>
      <tbody>
        {doctores.map(doc => (
          <tr key={doc.iduser} style={{ backgroundColor: '#f9f9f9', borderBottom: '1px solid #ddd' }}>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.name} {doc.apellidos}</td>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.edad || 'N/A'}</td>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.telefono || 'N/A'}</td>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.especialidad || 'N/A'}</td>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.cedula || 'N/A'}</td>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.pacientes_asignados}</td>
            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{doc.citas_agendadas}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MonitoreoDoctores;
